import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { Link } from "@opensea/next-ui-kit";
import { Tooltip } from "@opensea/ui-kit";
import { Edit } from "@opensea/ui-kit/icons";
import { isAddressEqual } from "@opensea/utils";
import { useTranslations } from "next-intl";
import { useAddress } from "@/hooks/wallet";
export const CollectionInfoEditButtonFragment = graphql(`
  fragment CollectionInfoEditButton on Collection {
    slug
    owner {
      address
    }
  }
`);
export function CollectionInfoEditButton(t0) {
  const $ = _c(8);
  const {
    collection: collectionKey
  } = t0;
  const t = useTranslations("CollectionInfoEditButton");
  const address = useAddress();
  const collection = readFragment(CollectionInfoEditButtonFragment, collectionKey);
  const doesOwnCollection = isAddressEqual(address, collection.owner?.address);
  if (!doesOwnCollection) {
    return;
  }
  let t1;
  if ($[0] !== t) {
    t1 = t("tooltip");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `/collection/${collection.slug}/edit`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Edit size={20} />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <span><Link href={t2} variant="unstyled">{t3}</Link></span>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1 || $[6] !== t4) {
    t5 = <Tooltip content={t1}>{t4}</Tooltip>;
    $[5] = t1;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}